import WeatherTabs from './weather-tabs';

const weatherTabsConfig = {
  name: 'weatherTabs',
  class: WeatherTabs,
  querySelector: {
    tabselect: '.weather-tabs__tabselect',
    tablist: '.weather-tabs__tablist',
  },
  querySelectorAll: {
    panels: '.weather-tabs__panel',
  },
};

export default weatherTabsConfig;

